import React, { Component } from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { isEmpty } from 'lodash';
import "./index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ViewTTSFlow extends Component {
    constructor(props) {
        super(props);
        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        const sitePath = slashes.concat(window.location.hostname);

        this.state = {
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            promptUploads: [],
            ttsTypeListApi: [],
            ttsRows: [],
            agentRows: [],
            groupAgentList: [],
            smsWebhookList: [],
            moduleList: [],
            webhookList: [],
            ivrList: [],
            ttsFlowName: '',
            language: '',
            gender: '',
            templateId: '',
            templateIdValue: '',
            dtmf: '',
            menuId: '',
            menuWaitTime: '',
            rePrompt: '',
            noInputId: '',
            wrongInputId: '',
            thanksId: '',
            noAgentId: '',
            sendWebhook: false,
            webhookId: '',
            sendSmsSuccess: false,
            sendSmsFail: false,
            sendSmsDtmf: false,
            sendSmsPatchFail: false,
            sendSmsPatchSuccess: false,
            callDurationSMS: 0,
            ivrFlag: false,
            ivrId: '',
            startDate: new Date(),
            endDate: new Date(),
            startTime: '',
            endTime: '',
            campaignIds: '',
            welcomePrompt: false,
            noinputPrompt: false,
            wronginputPrompt: false,
            thanksPrompt: false,
            noAgentPrompt: false
        }
    }

    componentDidMount() {
        const apiPath = this.state.apiPath;
        const userId = this.state.userId;
        const ttsFlowId = this.props.ttsFlowId;

        Fetcher.get(apiPath + `/api/obd/get/tts/flow/${ttsFlowId}`)
            .then(res => {
                const ttsFlow = JSON.parse(res.ttsFlow);
                const templateData = JSON.parse(res.templateData);
                let agentRows = [];
                if (res.agentRows) {
                    agentRows = JSON.parse(res.agentRows);
                }

                const smsData = JSON.parse(res.smsData);

                let language = ttsFlow.language === "en-IN" ? "English" : "Hindi";

                let templateIdValue = "";
                if (res.templateId === "7") {
                    templateIdValue = "TTS Simple IVR";
                } else if (res.templateId === "8") {
                    templateIdValue = "TTS DTMF";
                } else if (res.templateId === "9") {
                    templateIdValue = "TTS Call Patch";
                }

                const tts = JSON.parse(JSON.stringify(ttsFlow.ttsRows));
                let ttsListObj = {
                    "ttsList": tts.ttsList
                };
                console.log({ templateData })
                this.setState({
                    ttsFlowName: res.ttsFlowName,
                    language: language,
                    gender: ttsFlow.gender,
                    templateId: res.templateId,
                    templateIdValue: templateIdValue,
                    ttsRows: tts.ttsList,
                    ttsList: ttsListObj,
                    dtmf: templateData.dtmf,
                    menuId: templateData.menuPId,
                    menuWaitTime: templateData.menuWaitTime,
                    rePrompt: templateData.rePrompt,
                    noInputId: templateData.noInputPId,
                    noinputPrompt: templateData.noInputPId !== undefined && templateData.noInputPId !== "",
                    wrongInputId: templateData.wrongInputPId,
                    wronginputPrompt: templateData.wrongInputPId !== undefined && templateData.wrongInputPId !== "",
                    welcomeId: templateData.welcomePId,
                    thanksId: templateData.thanksPId,
                    thanksPrompt: templateData.thanksPId !== undefined && templateData.thanksPId !== "",
                    noAgentId: templateData.noAgentId,
                    noAgentPrompt: templateData.noAgentId !== undefined && templateData.noAgentId !== "",
                    agentRows: agentRows.patchList ?? [],
                    sendWebhook: smsData.webhook,
                    webhookId: smsData.webhookId,
                    sendSmsSuccess: smsData.smsSuccessApi.length > 0,
                    sendSmsFail: smsData.smsFailApi.length > 0,
                    sendSmsDtmf: smsData.smsDtmfApi.length > 0,
                    sendSmsPatchFail: smsData.callPatchFailMessage.length > 0,
                    sendSmsPatchSuccess: smsData.callPatchSuccessMessage.length > 0,
                    callDurationSMS: smsData.callDurationSMS,
                    startDate: res.startDate ? new Date(res.startDate) : new Date(),
                    endDate: res.endDate ? new Date(res.endDate) : new Date(),
                    startTime: res.startTime || '',
                    endTime: res.endTime || '',
                    campaignIds: res.campaignIds || '',
                    ivrFlag: res.ivrId !== undefined && res.ivrId !== "",
                    ivrId: res.ivrId || ''
                });
                // Get other data
                this.fetchPromptUploads();
                this.fetchTtsTypeList();
                this.fetchGroupAgentList();
                this.fetchModuleList();
                this.fetchIvrList();
                this.fetchWebhookList();
                this.fetchSmsWebhookList();
            })
            .catch(err => {
                console.log('Error in fetching TTS Flow Details', err);
            });
    }

    fetchPromptUploads = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/prompts/' + this.state.userId)
            .then(res => {
                this.setState({ promptUploads: res });
            })
            .catch(err => {
                console.log('Error in fetching PromptUpload Files', err);
            });
    }

    fetchTtsTypeList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/tts/type/list')
            .then(res => {
                this.setState({ ttsTypeListApi: res });
            })
            .catch(err => {
                console.log('Error in fetching TTS Type List', err);
            });
    }

    fetchGroupAgentList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/group/agent/list/' + this.state.userId)
            .then(res => {
                this.setState({ groupAgentList: res });
            })
            .catch(err => {
                console.log('Error in fetching Group Agent\'s', err);
            });
    }

    fetchModuleList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/module/list/' + this.state.userId)
            .then(res => {
                this.setState({ moduleList: res });
            })
            .catch(err => {
                console.log('Error in fetching Modules', err);
            });
    }

    fetchIvrList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/ivr/' + this.state.userId)
            .then(res => {
                this.setState({ ivrList: res });
            })
            .catch(err => {
                console.log('Error in fetching IVR List', err);
            });
    }

    fetchWebhookList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/webhooks/' + this.state.userId)
            .then(res => {
                this.setState({ webhookList: res });
            })
            .catch(err => {
                console.log('Error in fetching Webhooks', err);
            });
    }

    fetchSmsWebhookList = () => {
        Fetcher.get(this.state.apiPath + '/api/obd/sms/webhooks/' + this.state.userId)
            .then(res => {
                this.setState({ smsWebhookList: res });
            })
            .catch(err => {
                console.log('Error in fetching SMS Webhooks', err);
            });
    }

    getPromptName = (pid) => {
        if (!isEmpty(this.state.promptUploads) && !('error' in this.state.promptUploads)) {
            const match = this.state.promptUploads.find(fileObj =>
                pid == fileObj.promptId
            );
            return match ? match.fileName : "";
        }
        return "";
    }

    getWebhookName = (wid) => {
        if (!isEmpty(this.state.webhookList) && !('error' in this.state.webhookList)) {
            const match = this.state.webhookList.find(fileObj =>
                wid == fileObj.id
            );
            return match ? match.webhookName : "";
        }
        return "";
    }

    getIVRName = (wid) => {
        if (!isEmpty(this.state.ivrList) && !('error' in this.state.ivrList)) {
            const match = this.state.ivrList.find(fileObj =>
                wid == fileObj.ivrId
            );
            return match ? match.ivrName : "";
        }
        return "";
    }

    render() {
        // Create tables
        const ttsTable = this.state.ttsRows.map((item, index) => (
            <tr key={index}>
                <td>{item.ttsType}</td>
                <td>{item.value}</td>
                <td>{item.variableType}</td>
            </tr>
        ));

        const agentsTable = this.state.agentRows.map((item, index) => (
            <tr key={index}>
                <td>{item.groupName}</td>
                <td>{item.agentDtmf}</td>
            </tr>
        ));

        return (
            <Form className="add-tts-flow-form">
                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Header>View TTS Flow</Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Label>Template Type</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={this.state.templateIdValue}
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                        <Form.Group className="form-group" controlId="tts-flow-name">
                                            <Form.Label>Flow Name</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={this.state.ttsFlowName}
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Label>Language</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={this.state.language}
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={this.state.gender}
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={6}>
                                        <div className="react-bootstrap-table">
                                            <table className="table table-striped table-bordered table-sm widgetlist-table">
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Value</th>
                                                        <th>Variable Type</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ttsTable}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>

                                {this.state.campaignIds && this.state.campaignIds.trim() !== '' && (
                                    <Row>
                                        <Col sm={6}>
                                            <Card className="mb-3">
                                                <Card.Body>
                                                    <Row>
                                                        <Form.Label>Campaign Ids: </Form.Label>
                                                        <Col>
                                                            <div className="tag-input-container gap-2 d-flex w-fit flex-wrap">
                                                                {this.state.campaignIds
                                                                    .split(",")
                                                                    .map(id => id.trim())
                                                                    .filter(id => id !== '')
                                                                    .map((campaignId, index) => (
                                                                        <span key={index} className="badge badge-danger tag">
                                                                            {campaignId}
                                                                        </span>
                                                                    ))}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                )}

                                {(this.state.templateId === '8') && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group">
                                                <Form.Label>Selected DTMF</Form.Label>
                                                <Form.Control
                                                    readOnly
                                                    value={this.state.dtmf}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {(this.state.templateId === '8' || this.state.templateId === '9') && (
                                    <Row>
                                        <Col sm={4}>
                                            <Form.Label>Menu Wav File</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.getPromptName(this.state.menuId)}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Label>Menu Wait Time</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.state.menuWaitTime}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Label>Re-Prompt</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.state.rePrompt}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {(this.state.templateId === '8' || this.state.templateId === '9') && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Group className="form-group">
                                                <Form.Check
                                                    readOnly
                                                    checked={this.state.noinputPrompt}
                                                    label="Noinput File"
                                                    type="checkbox"
                                                />
                                                <Form.Check
                                                    readOnly
                                                    checked={this.state.wronginputPrompt}
                                                    label="Wronginput File"
                                                    type="checkbox"
                                                />
                                                <Form.Check
                                                    readOnly
                                                    checked={this.state.thanksPrompt}
                                                    label="Thanks File"
                                                    type="checkbox"
                                                />
                                                {this.state.templateId === '9' && (
                                                    <Form.Check
                                                        disabled
                                                        checked={this.state.noAgentPrompt}
                                                        label="No Agent File"
                                                        type="checkbox"
                                                    />
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.noinputPrompt && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Label>Noinput Wav File</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.getPromptName(this.state.noInputId)}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.wronginputPrompt && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Label>Wronginput Wav File</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.getPromptName(this.state.wrongInputId)}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.thanksPrompt && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Label>Thanks Wav File</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.getPromptName(this.state.thanksId)}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.noAgentPrompt && (
                                    <Row>
                                        <Col sm={6}>
                                            <Form.Label>No Agent Wav File</Form.Label>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    readOnly
                                                    value={this.getPromptName(this.state.noAgentId)}
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {(this.state.templateId === '9') && (
                                    <Row>
                                        <Col sm={6}>
                                            <div className="react-bootstrap-table">
                                                <table className="table table-striped table-bordered table-sm widgetlist-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Group</th>
                                                            <th>DTMF</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {agentsTable}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>
                                )}

                                <Row>
                                    <Col sm={3}>
                                        <Form.Group controlId="start-date">
                                            <Form.Label>Start Date</Form.Label>
                                            <DatePicker
                                                disabled
                                                className="form-control"
                                                selected={this.state.startDate}
                                                dateFormat="yyyy-MM-dd"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group controlId="end-date">
                                            <Form.Label>End Date</Form.Label>
                                            <DatePicker
                                                disabled
                                                className="form-control"
                                                selected={this.state.endDate}
                                                dateFormat="yyyy-MM-dd"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Label>Start Time</Form.Label>
                                        <Form.Control
                                            readOnly
                                            value={this.state.startTime}
                                            type="time"
                                        />
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Label>End Time</Form.Label>
                                        <Form.Control
                                            readOnly
                                            value={this.state.endTime}
                                            type="time"
                                        />
                                    </Col>
                                </Row>

                                {(this.state.webhookFlag) && (
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group controlId="Send-later">
                                                <Form.Check
                                                    disabled
                                                    checked={this.state.sendWebhook}
                                                    label="Enable Webhook"
                                                    type="checkbox"
                                                />
                                            </Form.Group>
                                        </Col>
                                        {this.state.sendWebhook && (
                                            <Col sm={3}>
                                                <Form.Group>
                                                    <Form.Label>Webhook</Form.Label>
                                                    <Form.Control
                                                        readOnly
                                                        value={this.getWebhookName(this.state.webhookId)}
                                                        type="text"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {(this.state.customIvrFlag) && (
                                    <Row>
                                        <Col sm={3}>
                                            <Form.Group controlId="Send-later">
                                                <Form.Check
                                                    disabled
                                                    checked={this.state.ivrFlag}
                                                    label="Custom IVR"
                                                    type="checkbox"
                                                />
                                            </Form.Group>
                                        </Col>
                                        {this.state.ivrFlag && (
                                            <Col sm={3}>
                                                <Form.Group>
                                                    <Form.Label>Custom IVR</Form.Label>
                                                    <Form.Control
                                                        readOnly
                                                        value={this.getIVRName(this.state.ivrId)}
                                                        type="text"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default ViewTTSFlow;